import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { DivisionClient, DivisionView, SearchDivisionsParameters } from './api-proxies';
import { CustomizableEntityService } from './customizable-entity-service';
import { ISearchCustomInfoEntityParameters } from './search-custom-info-entity-parameters';

@Injectable({
    providedIn: 'root'
})
export class DepartmentService extends CustomizableEntityService {
    constructor(private readonly client: DivisionClient) {
        super();
    }

    async search(parameters: ISearchCustomInfoEntityParameters): Promise<DivisionView[]> {
        return await lastValueFrom(this.client.divisionSearch(parameters as SearchDivisionsParameters));
    }

    async getById(id: number): Promise<DivisionView> {
        return await lastValueFrom(this.client.divisionGetById(id));
    }

    async save(body: DivisionView[]): Promise<DivisionView[]> {
        return await lastValueFrom(this.client.divisionSave(body));
    }

    async activate(id: number): Promise<void> {
        return await lastValueFrom(this.client.divisionActivate(id));
    }

    async deactivate(id: number): Promise<void> {
        return await lastValueFrom(this.client.divisionDeactivate(id));
    }
}
